module.exports = cptable;


//////////////////
// WEBPACK FOOTER
// external "cptable"
// module id = 788
// module chunks = 63